import { createStore } from 'vuex'

export default createStore ({
  state :  {
    users: [],
    userid:sessionStorage.getItem("userid")?sessionStorage.getItem("userid"):""
  },
  getters: {
  },
  mutations: {
    setUsers :(state,payload) =>{
      state.users = payload

    },
  },
  actions: {
  },
})